<div class="freemode-carousel ion-padding-horizontal ion-padding-bottom marb5">
  <h6
    *ngIf="title"
    class="title ion-no-margin padt10 title-text-color fs-4 font600"
  >
    {{ title }}
  </h6>
  <swiper-container
    pager="true"
    [spaceBetween]="10"
    [slidesPerView]="2"
    [freeMode]="true"
    [passiveListeners]="true"
  >
    <swiper-slide *ngFor="let item of list">
      <benefit-card [data]="item" [baseUrl]="baseUrl"> </benefit-card>
    </swiper-slide>
  </swiper-container>
</div>
